/**
 * Labstep
 *
 * @module components/EntityView/Form/ShowEdit/Name
 * @desc Update EntityView name
 */

import { convertToHeader } from 'labstep-web/components/Entity/PrimaryInfo';
import { fieldEntityName } from 'labstep-web/components/Entity/PrimaryInfo/fields';
import { Flex } from 'labstep-web/core/Flex';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { EntityViewFormShowEditNameProps } from './types';

export const EntityViewFormShowEditName: React.FC<
  EntityViewFormShowEditNameProps
> = ({ entityView }) => {
  return (
    <Flex vAlignContent="center">
      <Icon name={'table'} cornerIcon={'bolt'} />
      <ShowEditText
        entity={entityView}
        entityName={entityView.entityName}
        field={{ ...fieldEntityName, header: false }}
      >
        {entityView.displayName}
      </ShowEditText>
    </Flex>
  );
};
